<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-17 16:39:25
 -->
<template>
  <div class="loading">
    <div id="login-box">
      <h2>欢迎使用“音乐萌笛学院俱乐部”会员系统</h2>
      <h3>我们将热诚为你服务</h3>
      <!-- <h1>登录</h1> -->
      <div class="input-box">
        <input placeholder="请输入用户名" v-model="userName" />
      </div>
      <div class="input-box">
        <input type="password" placeholder="请输入密码" v-model="passWord" />
      </div>
      <div
        class="input-box"
        style="
          display: flex;
          justify-content: space-around;
          margin-bottom: 21px;
        "
      >
        <el-checkbox v-model="state">记住账号密码</el-checkbox>
        <div class="boxss">
          <span @click="jumppass">忘记密码</span>
          <span @click="jump" style="color: #22548cff">注册</span>
        </div>
      </div>

      <button @click="login" :class="{ btns: userName && passWord != '' }">
        登录
      </button>
      <div class="input-box" v-if="tipshow">
        <span style="color: red">账号正在审核中、请稍后再试</span>
      </div>

      <layer :layer="layerObj" :showClose="true" @close='closeDialog'>
        <resetPassword :loginName="userName" @call="callback"></resetPassword>
      </layer>
    </div>

    <!-- <div class="box">
      <ul>
        <li>
          <label for="">账号</label>
          <el-input placeholder="请输入用户名" v-model="userName"></el-input>
        </li>
        <li>
          <label for="">密码</label>
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="passWord"
          ></el-input>
        </li>
        <li class="yzm">
          <label for="">图片验证码</label>
          <img @click="getlogincapcha" :src="base64Img" alt="" srcset="" />
        </li>
        <li>
          <label for="" style="width: 100%; display: inline-block"
            >请输入图片中加减乘除的值</label
          >
          <el-input placeholder="请输入验证码" v-model="code"></el-input>
        </li>
        <li class="tips">
          <el-checkbox v-model="state">记住账号密码</el-checkbox>
          <div class="boxss">
            <span @click="jump">注册</span>
            <span @click="jumppass">忘记密码</span>
          </div>
        </li>
        <li>
          <div class="btn" @click="login">登录</div>
        </li>
      </ul>
    </div>-->
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import { userlogin, logincapcha } from "@/api/file";
import utils from "@/plugins/utils";
import { download, webGet } from "@/api/download";
import cookies from "@/plugins/utils/cookies";
import resetPwd from "@/mixins/resetPwd";
export default {
  data() {
    return {
      state: false,
      userName: "",
      passWord: "",
      code: "",
      uuid: "",
      base64Img: "",
      values: "",
      tipshow: false,
    };
  },
  mixins: [resetPwd],
  mounted() {
    this.getCookie();
  },
  methods: {
    //跳转注册
    jump() {
      this.$router.push("/regist");
    },
    //跳转忘记密码
    jumppass() {
      this.$router.push("/password");
    },
    base64ImgtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    //获取登录验证码
    getlogincapcha() {
      logincapcha().then((res) => {
        this.base64Img = "data:image/png;base64," + res.data.img;
        this.uuid = res.data.key;
        //  this.base64Img=this.base64ImgtoFile(img)
      });
    },
    //登录
    login() {
      let that = this
      let data = {
        username: this.userName,
        password: this.fromatPassword(this.passWord),
        userType: 0,
        code: this.code,
        uuid: this.uuid,
      };
      userlogin(data).then((res) => {
        if (res.code === 0) {
          utils.cookies.set("token", res.data.access_token);
          sessionStorage.setItem("tokens", res.data.access_token);
          this.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            showClose:false,
            callback: action => {
                that.resetFormData.userId = res.data.userId
                that.layerObj.show = true
            }
          });
        } else {
          if (this.state) {
            this.setCookie();
          } else {
            this.clearCookie();
          }
          if (res.code == 200) {
            localStorage.setItem("states", 2);
            // localStorage.setItem('token',res.data.access_token)
            utils.cookies.set("token", res.data.access_token);
            sessionStorage.setItem("tokens", res.data.access_token);
            sessionStorage.setItem("userId", res.data.userId);
            this.$message.success("登录成功");
            if (this.$route.query.value && this.$route.query.cy == "true") {
              this.$router.push({
                path: "/pageindex",
                query: {
                  value: this.$route.query.value,
                  cy: this.$route.query.cy,
                },
              });
            } else if (this.$route.query.value) {
              if (process.env.NODE_ENV === "development") {
                window.open(
                  "http://47.118.54.142:8889/apiw/web/download?value=" +
                    this.$route.query.value +
                    "&token=" +
                    res.data.access_token,
                  "_blank"
                );
              } else {
                window.open(
                  "http://47.118.54.142:8889/apiw/web/download?value=" +
                    this.$route.query.value +
                    "&token=" +
                    res.data.access_token,
                  "_blank"
                );
              }

              this.$router.push("/web/myinfo");
            } else {
              this.$router.push("/web/myinfo");
            }
            // this.$router.push('/web/myinfo')
            // this.getlogincapcha()
            //       if(localStorage.getItem('value')){
            //           this.$router.push('/pageindex')
            //       }else{
            //         this.$router.push('/web/myinfo')
            //       }
          } else if (res.msg == "该用户审核中,请稍后...") {
            this.tipshow = true;
          }
        }
      });
    },

    /*
              点击登录调用设置上cookie  
              参数：用户名-密码-到期天数
            */
    setCookie(
      username = this.userName,
      password = this.passWord,
      num = 7,
      state = this.state
    ) {
      const time = new Date();
      time.setTime(time.getTime() + 24 * 60 * 60 * 1000 * num);
      //加上window.btoa是为了对用户名和密码进行编码，不让cookie明文展示
      window.document.cookie = `userName=${Base64.encode(
        username
      )}; path=/; expires=${time.toGMTString()}`;
      window.document.cookie = `passWord=${Base64.encode(
        password
      )}; path=/; expires=${time.toGMTString()}`;
      window.document.cookie = `state=${Base64.encode(
        state
      )}; path=/; expires=${time.toGMTString()}`;
      // localStorage.setItem("state", true);
    },

    /* 读取cookie */
    getCookie() {
      if (document.cookie.length > 0) {
        const cookieArr1 = document.cookie.split(";");
        for (let i in cookieArr1) {
          const cookieArr2 = cookieArr1[i].split("=");
          //避免输入中含有空格，消除文本框空格
          cookieArr2[0] = cookieArr2[0].replace(/\s+/g, "");
          cookieArr2[1] = cookieArr2[1].replace(/\s+/g, "");

          if (cookieArr2[0] == "userName") {
            //读取cookie然后进行解码
            this.userName = Base64.decode(cookieArr2[1]);
          } else if (cookieArr2[0] == "passWord" && cookieArr2[1]) {
            this.passWord = Base64.decode(cookieArr2[1]);
          } else if (cookieArr2[0] == "state" && cookieArr2[1]) {
            if (Base64.decode(cookieArr2[1]) == "true") {
              this.state = true;
            } else {
              this.state = false;
            }
          }
        }
      }
    },

    /* 清除cookie */
    clearCookie() {
      if (document.cookie.length > 0) {
        const cookieArr1 = document.cookie.split(";");
        for (let i in cookieArr1) {
          const cookieArr2 = cookieArr1[i].split("=");
          //避免输入中含有空格，消除文本框空格
          cookieArr2[0] = cookieArr2[0].replace(/\s+/g, "");
          cookieArr2[1] = cookieArr2[1].replace(/\s+/g, "");

          if (cookieArr2[0] == "userName") {
            //读取cookie然后进行解码
            document.cookie =
              "userName=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
          } else if (cookieArr2[0] == "passWord" && cookieArr2[1]) {
            document.cookie =
              "passWord=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
          } else if (cookieArr2[0] == "state" && cookieArr2[1]) {
            document.cookie = "state=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
          }
        }
      }
    },
  },
};
</script>

<style scoped="" lang="scss">
* {
  padding: 0;
  margin: 0;
}
input::placeholder {
  font-size: 16px;
  letter-spacing: 1px;
  color: #b9bed1 !important;
}
input::-webkit-input-placeholder {
  font-size: 16px;
  letter-spacing: 1px;
  color: #b9bed1 !important;
}
input::-ms-input-placeholder {
  font-size: 16px;
  letter-spacing: 1px;
  color: #b9bed1 !important;
}
input::-moz-placeholder {
  font-size: 16px;
  letter-spacing: 1px;
  color: #b9bed1 !important;
}
#login-box {
  text-align: center;
  width: 595px;
  height: 575px;
  background: #ffffff;
  box-shadow: 0px 7px 27px 0px rgba(133, 169, 231, 0.51);
  border-radius: 10px;
  opacity: 0.6;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -287px;
  margin-left: -297px;
}

#login-box h1 {
  padding-top: 30px;
  color: #ffffff;
}
#login-box h2 {
  padding-top: 59px;
  font-size: 20px;
  color: #22548cff;
}
#login-box h3 {
  padding-top: 30px;
  font-size: 20px;
  color: #22548cff;
}
#login-box .input-box {
  margin-top: 34px;
}
#login-box .input-box:first-of-type {
  margin-top: 55px;
}
#login-box .yzma {
  display: flex;
  justify-content: center;
  img {
    width: 100px;
  }
  input {
    width: 100px;
    padding-top: 10px !important;
  }
}
#login-box .input-box input {
  width: 385px;
  height: 59px;
  border: 2px solid #eeeeee;
  border-radius: 16px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #b9bed1;
  line-height: 90px;
  outline: none;
  padding-left: 10px;
}
input::-webkit-input-placeholder {
  color: white;
  font-size: 12px;
}
#login-box button {
  width: 385px;
  height: 59px;

  background: #2b629f;
  opacity: 0.5;
  font-size: 26px;
  font-family: Microsoft YaHei;

  font-weight: 400;
  color: #ffffff;
  border-radius: 16px;
  cursor: pointer;
}

// #login-box button:hover {
//   background-image: linear-gradient(to top, #30cfd0 0%, #330867 100%);
// }
#login-box .input-box i {
  color: #ffffff;
}
.loading {
  width: 100%;
  background: #29557b;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url(../../../assets/images/bglog.png);
  background-size: 100%;
}

// .box {
//   height: 100%;
//   margin: auto;
//   width: 60%;
//   background: white;
// }

// .box ul {
//   position: relative;
//   top: 120px;
//   padding-left: 120px;
//   padding-right: 120px;
//   .yzm {
//     label {
//       display: inline-block;
//       line-height: 63px;
//       float: left;
//     }
//     img {
//       margin-left: 10px;
//     }
//   }
// }

// .box ul > li {
//   margin-top: 14px;
//   width: 100%;
// }

// .box ul > li p {
// }

// .box ul > li > div {
//   width: 80%;
//   margin-left: 20px;
// }

// .box ul > li div > label {
//   font-size: 20px;
//   font-family: Microsoft YaHei;
//   font-weight: 400;
//   color: #3c4353;
//   line-height: 34px;
// }

// .box ul > li div > label span {
//   color: #fc524c;
// }

// .box ul > li div > .el-input {
//   min-width: 90%;
//   margin-left: 20px;
// }

// .box ul > li div > .el-input .el-input-group__append {
//   background: #167afc;
//   color: rgba(255, 255, 255, 1);
//   cursor: pointer;
//   opacity: 0.5;
// }

// .box ul > li p {
//   font-size: 16px;
//   font-family: Microsoft YaHei;
//   font-weight: 400;
//   color: #24558b;
//   line-height: 34px;
// }

// .btn {
//   width: 82% !important;
//   height: 60px;
//   background: #24558b;
//   opacity: 0.5;
//   border-radius: 4px;
//   text-align: center;
//   font-size: 24px;
//   font-family: Microsoft YaHei;
//   font-weight: 400;
//   color: #ffffff;
//   line-height: 60px;
//   cursor: pointer;
// }

// .updata {
//   justify-content: flex-end;
// }

// .tips {
//   justify-content: space-between !important;
// }

.boxss {
  color: #b9bed1ff;

  span {
    cursor: pointer;
    margin-right: 20px;
  }
}
.btns {
  background: #1a74c6 !important;
  opacity: 1 !important;
  border: 0;
}
</style>
